import { useQuery } from '@redwoodjs/web';

import { GET_DEFER_RENEWAL_MONTHS } from 'src/graphql/queries/deferRenewalMonths.query';
import { DeferRenewalMonths } from 'types/graphql';

interface UseDeferRenewalMonthsReturn {
    deferRenewalMonths: DeferRenewalMonths[];
    loading: boolean;
    error?: Error;
    refetch: () => void;
}

const useDeferRenewalMonths = (): UseDeferRenewalMonthsReturn => {
    const { data, loading, error, refetch } = useQuery(GET_DEFER_RENEWAL_MONTHS, {
        fetchPolicy: 'cache-first',
    });

    return {
        deferRenewalMonths: data?.deferRenewalMonths || [],
        loading,
        error,
        refetch,
    };
};

export default useDeferRenewalMonths;
